export const DEFAULT_MAX_COLOR_COUNT = 4
export const EVENT_COLOR_CHANGE = 'EVENT_COLOR_CHANGE'
